/**
 * @name fields_main
 * The list of all pre-defined fields of the list (main) table
 */
const ORDER_MAIN = [
  {
    slug: 'item_no', // The name of the field from back-end, unique one word
    pre_slug: 'row', // Is needed for the act's understanding that this field is not of act type
    name: '', // Name that is displayed in the table header
    width: 'min', // tiny|narrow|wide – width of the column if not provided by back-end

    // Objects of different properties that will be used in proper row of the table
    // For example, `header.class` goes into the item_no column of the header row
    header: {
      class: 'cell-header-span-col cell-id-icons',
      allowAddColumn: true,
    },
    group: {
      type: 'index', // Type is used to distinguish what component exactly do you need
      allowPaste: false,
      allowCopy: false,
    },
    row: {
      type: 'index',
    },
    total: {
      type: 'index',
    },
    tax: {
      type: 'index',
    },
  },
  {
    slug: 'description_of_works',
    pre_slug: 'row',
    name: 'description of work',
    width: 'wide',
    header: {
      class: 'cell-header-span-col cell-header-description',
      resizable: true,
      allowAddColumn: true,
    },
    group: {
      type: 'description',
      allowPaste: true,
      allowCopy: true,
    },
    row: {
      type: 'description',
    },
    total: {
      type: 'name',
    },
    tax: {
      type: 'input',
      copypaste: true,
      slug: 'name',
    },
  },
  {
    slug: 'custom',
    pre_slug: 'row',
    name: '',
    width: 'wide',
    header: {
      class: 'cell-header-span-col',
      changeable: true,
      resizable: true,
      allowDeleteColumn: true,
      allowAddColumn: true,
    },
    group: {
      type: '',
    },
    row: {
      type: 'text',
    },
    total: {
      type: 'empty',
    },
    tax: {
      type: 'empty',
    },
  },
  {
    slug: 'unit',
    pre_slug: 'row',
    name: 'unit',
    width: 'tiny',
    type: 'unit',
    header: {
      class: 'cell-header-span-col',
      allowAddColumn: true,
    },
    group: {
      type: 'empty',
      allowPaste: false,
      allowCopy: false,
    },
    row: {
      type: 'unit',
    },
    total: {
      type: 'empty',
    },
    tax: {
      type: 'empty',
    },
  },
  {
    slug: 'quantity',
    pre_slug: 'row',
    name: 'quantity',
    width: 'tiny',
    header: {
      class: 'cell-header-span-col',
      allowAddColumn: true,
    },
    group: {
      type: '',
    },
    row: {
      type: 'number',
      noCurrency: true,
    },
    total: {
      type: 'empty',
    },
    tax: {
      type: 'empty',
    },
  },
  {
    slug: 'comments',
    pre_slug: 'row',
    name: 'comments',
    width: 'narrow',
    header: {
      class: 'cell-header-span-col',
      allowAddColumn: true,
    },
    group: {
      type: '',
    },
    row: {
      type: 'comments',
    },
    total: {
      type: 'empty',
    },
    tax: {
      type: 'empty',
    },
  },
  {
    slug: 'contractor',
    pre_slug: 'row',
    name: 'status',
    width: 'narrow',
    header: {
      class: 'cell-header-span-col',
      allowAddColumn: true,
    },
    group: {
      type: '',
    },
    row: {
      type: 'contractor',
    },
    total: {
      type: 'empty',
    },
    tax: {
      type: 'empty',
    },
  },
  {
    slug: 'price_per_hour',
    pre_slug: 'row',
    name: 'price per hour',
    width: 'narrow',
    required: true,
    header: {
      class: 'sticky-16',
      hourlyRateOption: true,
    },
    group: {
      type: '',
    },
    row: {
      type: 'number',
    },
    total: {
      type: 'empty',
    },
    tax: {
      type: 'empty',
    },
  },
  {
    slug: 'working_hours',
    pre_slug: 'row',
    name: 'working hours',
    width: 'narrow',
    required: true,
    header: {
      class: 'sticky-16',
      hourlyRateOption: true,
    },
    group: {
      type: '',
    },
    row: {
      type: 'number',
      noCurrency: true,
    },
    total: {
      type: 'empty',
    },
    tax: {
      type: 'empty',
    },
  },
  {
    slug: 'labour',
    pre_slug: 'row',
    name: 'labour',
    width: 'tiny',
    header: {
      class: 'sticky-16',
      hourlyRateOption: true,
    },
    group: {
      type: '',
    },
    row: {
      type: 'number',
    },
    total: {
      type: 'empty',
    },
    tax: {
      type: 'empty',
    },
  },
  {
    slug: 'materials',
    pre_slug: 'row',
    name: 'materials',
    width: 'tiny',
    header: {
      class: 'sticky-16',
    },
    group: {
      type: '',
    },
    row: {
      type: 'number',
    },
    total: {
      type: 'empty',
    },
    tax: {
      type: 'empty',
    },
  },
  {
    slug: 'tools',
    pre_slug: 'row',
    name: 'tools',
    width: 'tiny',
    header: {
      class: 'sticky-16',
    },
    group: {
      type: '',
    },
    row: {
      type: 'number',
    },
    total: {
      type: 'empty',
    },
    tax: {
      type: 'empty',
    },
  },
  {
    slug: 'total',
    pre_slug: 'row',
    name: 'total',
    width: 'tiny',
    header: {
      class: 'sticky-16',
    },
    group: {
      type: '',
    },
    row: {
      type: 'number',
      readonly: true,
    },
    total: {
      type: 'empty',
    },
    tax: {
      type: 'empty',
    },
  },
  {
    slug: 'labour_total',
    pre_slug: 'row',
    name: 'labour',
    width: 'tiny',
    header: {
      class: 'sticky-16',
    },
    group: {
      type: '',
    },
    row: {
      type: 'number',
      readonly: true,
    },
    total: {
      type: 'number',
    },
    tax: {
      type: 'percent',
      slug: 'percent_labour',
      value: 'labour',
    },
  },
  {
    slug: 'materials_total',
    pre_slug: 'row',
    name: 'materials',
    width: 'tiny',
    header: {
      class: 'sticky-16',
    },
    group: {
      type: '',
    },
    row: {
      type: 'number',
      readonly: true,
    },
    total: {
      type: 'number',
    },
    tax: {
      type: 'percent',
      slug: 'percent_materials',
      value: 'materials',
    },
  },
  {
    slug: 'tools_total',
    pre_slug: 'row',
    name: 'tools',
    width: 'tiny',
    header: {
      class: 'sticky-16',
    },
    group: {
      type: '',
    },
    row: {
      type: 'number',
      readonly: true,
    },
    total: {
      type: 'number',
    },
    tax: {
      type: 'percent',
      slug: 'percent_tools',
      value: 'tools',
    },
  },
  {
    slug: 'total_total',
    pre_slug: 'row',
    name: 'total',
    showCurrency: true,
    width: 'tiny',
    header: {
      class: 'sticky-16 cell-total',
      fixRight: 'list',
    },
    group: {
      type: '',
    },
    row: {
      type: 'number',
      readonly: true,
    },
    total: {
      type: 'number',
    },
    tax: {
      type: 'percent',
      slug: 'percent_total',
      value: 'total',
    },
  },
];

export default ORDER_MAIN;
